import React from 'react';
import BaseComponent from './Base';
import { Link } from 'react-router-dom';

class SpecialPersons extends BaseComponent {
  constructor(props) {
    let config = {
      subModuleName : 'persons',
      filterParams: [
        {value:'',name:"p",type:"string",default:''},
        {value:'',name:"r",type:"string",default:''},
        {value:'',name:"o",type:"string",default:''},
      ]
    };

    super(props, config);
    this.state.list_url= '/api/organ/persons/';
    this.state.get_url= '/api/organ/persons/';

    this.state.on_edit=(person_id,params)=>{
      this.setState({id_to_edit:person_id});
    };
  }
  loadAffilationsOptions(inputValue, callback){
    setTimeout(() => {
      fetch("/api/organ/ajax/realobjects/", {
        method: "post",
        body: JSON.stringify({ "term": inputValue , parent_id:this.state.data.person.role_id }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json())
        .then(records => {
          let items = [];
          records.map(_record => items.push({ value: _record.object_id, label: _record.title }));
          callback(items);
        })
  
    }, 50);
  }
  componentWillReceiveProps(props){
    this.setSearchValues("p","");
    this.setSearchValues("r","");
    this.setSearchValues("o","");

    super.componentWillReceiveProps(props);
  }
  renderTempPersonCard(t,isMain,RealPerson){
    if (this.isNull(t)) return null;

    var r = null;
    var record = record = JSON.parse(t.data);
    if (!isMain && !this.isNull(record.special_person_id)) return null;
    r = <div className="col-md-2 col-sm-12 col-xs-12">
          <div className="box box-warning">
            <div className="box-body">
              <ul className="products-list product-list-in-box">
                <div className="item">
                  <p className="message">
                    <p>
                      <Link to={"/person/edit/" + t.id} className="name">
                        {this.isBlank(record.pic) ?
                          <img src={"/assets/images/no-pic.gif"} style={{"width": "160px","height": "165px"}} />
                        :
                          <img src={"/media/temp_organ/" + record.pic} style={{"width": "160px","height": "165px"}} />
                        }
                        {isMain ?
                          RealPerson.fname + " " + RealPerson.lname
                        :
                          record.fname + " " + record.lname
                        }
                      </Link>
                    </p>
                    <span className="label label-info pull-left">در انتظار تایید</span>
                  </p>
                </div>
              </ul>
            </div>
          </div>
        </div>
    return r;
  }
  modified(id){
    var modify = null;
    this.state.data.temps.forEach(t=>{
      var record = JSON.parse(t.data);
      if (record.special_person_id == id) modify = t;
    });
    return modify;
  }
  renderListView(){
    return (
      <div>
        <div className="row" style={{"marginBottom":"19px"}}>
          <div className="col-md-12 col-sm-12 col-xs-12">
            <Link to="/person/new/" className="btn btn-success">
              <i className="fa fa-plus"></i> افزودن فرد جدید
            </Link>
          </div>
        </div>
        {this.state.data.records.length > 0  || this.state.data.temps.length > 0 ?[
          this.state.data.temps.length > 0 &&
            <div className="row">
              {this.state.data.temps.map(_t=>
                this.renderTempPersonCard(_t,false,null)
              )}

              {this.state.data.records.map(_t=>
                this.renderTempPersonCard(this.modified(_t.id),true,_t.RealPerson)
              )}
            </div>
          ,
          this.state.data.records.length > 0 &&
            <div className="row">
              {this.state.data.records.map(_t=>
                this.isNull(this.modified(_t.id)) &&
                  <div className="col-md-2 col-sm-12 col-xs-12">
                    <div className="box box-success">
                      <div className="box-body">
                        <ul className="products-list product-list-in-box">
                          <div className="item">
                            <p className="message">
                              <p>
                                <Link to={"/person/edit/main/" + _t.id} className="name">
                                <img src={this.toImageUrl(_t.RealPerson,"real_person",true)} style={{"width": "160px","height": "165px"}} />
                                  {_t.RealPerson.fname} {_t.RealPerson.lname}</Link>
                              </p>
                              {_t.RealPerson.display === 1 &&
                                <a className="label label-info pull-right" target='_blank' href={"/p/" + (_t.RealPerson.person_id < 170000 ? _t.RealPerson.old_id_in_civilica : _t.RealPerson.person_id) + "/"}>مشاهده رزومه</a>
                              }
                              <span className="label label-info pull-left">{this.isNull(_t.Role) ? _t.desc : _t.Role.title}</span>
                            </p>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
              )}
            </div>
        ]:
          <h4 className="alert alert-info text-center">کاربر گرامی در حال حاضر شما آیتم ثبت شده ای ندارید</h4>
        }
      </div>
    );
  }
  render() {
    if (this.state.data === null || this.state.data === undefined)
      return this.showLoading();
    if (this.state.data.status === 500 || this.state.data.status === 0)
      return this.render500()
    if (this.state.data.status === 404)
      return this.render404()
    if (this.state.data.status === 2)
      return this.renderNoAccess();
    if (this.state.data.status === 4)
      return this.renderNoLogin();
    return this.renderListView();
  }
}
export default SpecialPersons;